import React, { PureComponent } from 'react';
import { Row, Col, Checkbox, Button } from 'antd';
import { groupBy } from '../../utils/utils';

const CheckboxGroup = Checkbox.Group;
class RegionsView extends PureComponent {
  state = {
    selectedRegions: [],
  };

  // applySelected = () => {
  //   const { selectedRegions } = this.state;
  //   this.props.selectedRegions(selectedRegions);
  // };

  onChange = checkedList => {
    this.setState({ selectedRegions: checkedList }, () => this.props.selectedRegions(checkedList));
    // this.setState({
    //   selectedRegions: checkedList,
    // });
  };
  resetRegions = () => {
    this.props.resetRegions();
    this.setState({
      selectedRegions: [],
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedCloud !== this.props.selectedCloud) {
      this.resetRegions();
    }
  }

  onCheckAllChange = e => {
    const allRegions = [];
    this.props.regions.map(val => {
      allRegions.push(val.region);
    });
    this.props.selectedRegions(allRegions);
    this.setState({
      selectedRegions: allRegions,
    });
  };
  render() {
    const { selectedCloud, checkedRegions } = this.props;
    let groupedRegionsByType = groupBy(this.props.regions, 'type');
    return (
      <div style={{ maxHeight: '200px', overflowY: 'auto', width: '600px' }}>
        <div style={{ float: 'right', marginRight: '12px' }}>
          <Button
            type="primary"
            style={{ fontSize: '12px', marginRight: '8px' }}
            onClick={this.onCheckAllChange}
          >
            Select All
          </Button>
          {/* <Button style={{ fontSize: '12px' }} onClick={this.applySelected}>
            Apply
          </Button> */}
        </div>
        <Checkbox.Group
          style={{ width: '100%' }}
          onChange={this.onChange}
          value={checkedRegions.length > 0 ? checkedRegions : this.state.selectedRegions}
        >
          <Row>
            {Object.entries(groupedRegionsByType).map((item, i) => {
              return (
                <Col span={7} key={i}>
                  <p style={{ color: '#B1B2B1', fontSize: '12px', marginBottom: '8px' }}>
                    {item[0]}
                  </p>
                  {item[1].map((val, index) => {
                    return (
                      <div key={index}>
                        <Checkbox
                          style={{ marginBottom: '8px', marginTop: '-9px', fontSize: '11px' }}
                          value={val.region}
                          key={val.region}
                        >
                          {selectedCloud === 'AWS'
                            ? `${val.region  } (${val.regionName})`
                            : val.region}
                        </Checkbox>
                        <br />
                      </div>
                    );
                  })}
                </Col>
              );
            })}
          </Row>
        </Checkbox.Group>
        {/* <div style={{ float: 'right', marginRight: '12px' }}>
          <Button
            type="primary"
            style={{ fontSize: '12px', marginRight: '8px' }}
            onClick={this.onCheckAllChange}
          >
            Select All
          </Button>
          <Button style={{ fontSize: '12px' }} onClick={this.applySelected}>
            Apply
          </Button>
        </div> */}
      </div>
    );
  }
}
export default RegionsView;
